import * as React from 'react';
import { connect } from 'react-redux';
import preload from 'redux-preload';
import Radium from 'radium';

@connect(({ faq: { questions } }) => ({ questions }))
@preload(() => ({ type: 'FETCH_FAQ' }))
@Radium
export default class FAQ extends React.Component {
  static propTypes = {
    questions: React.PropTypes.arrayOf(React.PropTypes.object).isRequired
  }

  render() {
    const { questions } = this.props;

    return (
      <div style={styles.base}>
        {questions.map(({ question, answer, id }) =>
          <div style={styles.faq} key={`question-${id}`}>
            <div style={styles.question}>{question}</div>
            <div style={styles.base}>{answer}</div>
          </div>
        )}
      </div>);
  }
}

const styles = {
  base: {
    marginBottom: 50,
    fontSize: 18,
    textAlign: 'justify'
  },
  question: {
    fontWeight: 'bold',
    marginBottom: 5
  },
  faq: {
    marginBottom: 15
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/faq/index.jsx